const isSliceValueFilled = (value) =>
    value !== null && value !== undefined && value !== "";

export const getDaySliceFieldPaths = (days = []) => {
    const paths = [];

    days.forEach((day, dayIndex) => {
        if (day.off) return;

        (day.slices || []).forEach((_, sliceIndex) => {
            paths.push(`days.${dayIndex}.slices.${sliceIndex}.start`);
            paths.push(`days.${dayIndex}.slices.${sliceIndex}.end`);
        });
    });

    return paths;
};

export const validateDaySlices = (days = []) => {
    const fieldErrors = [];

    days.forEach((day, dayIndex) => {
        if (day.off) return;

        const slices = day.slices || [];
        if (slices.length === 0) {
            fieldErrors.push({
                path: `days.${dayIndex}.slices`,
                message: "Add at least one time slot",
            });
            return;
        }

        slices.forEach((slice, sliceIndex) => {
            const startPath = `days.${dayIndex}.slices.${sliceIndex}.start`;
            const endPath = `days.${dayIndex}.slices.${sliceIndex}.end`;

            if (!isSliceValueFilled(slice.start)) {
                fieldErrors.push({ path: startPath, message: "Start time is required" });
            }
            if (!isSliceValueFilled(slice.end)) {
                fieldErrors.push({ path: endPath, message: "End time is required" });
            }

            if (isSliceValueFilled(slice.start) && isSliceValueFilled(slice.end) && slice.end <= slice.start) {
                fieldErrors.push({ path: endPath, message: "End time must be after start time" });
            }

            if (sliceIndex > 0) {
                const prevSlice = slices[sliceIndex - 1];
                if (
                    isSliceValueFilled(slice.start) &&
                    isSliceValueFilled(prevSlice.end) &&
                    slice.start < prevSlice.end
                ) {
                    fieldErrors.push({
                        path: startPath,
                        message: "Time slot must start after the previous slot ends",
                    });
                }
            }
        });
    });

    return {
        isValid: fieldErrors.length === 0,
        fieldErrors,
    };
};
